import { render } from "./AppContentSlides.vue?vue&type=template&id=78d2b60f&scoped=true"
import script from "./AppContentSlides.vue?vue&type=script&lang=js"
export * from "./AppContentSlides.vue?vue&type=script&lang=js"

import "./AppContentSlides.vue?vue&type=style&index=0&id=78d2b60f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d2b60f"]])

export default __exports__